import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Eye, EyeOff, Mail, Lock } from 'lucide-react';
import { Button, FormField, IconButton, Input } from '@ntconsult/aluma-react';
import { useLogin } from '../hooks/useLogin';

export function LoginForm() {
  const { t } = useTranslation('auth');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { mutate: login, isPending } = useLogin();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    login({ email, password });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <FormField label={t('email')}>
        <Input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={t('emailPlaceholder')}
          required
          leftIcon={<Mail className="w-4 h-4" aria-hidden="true" />}
        />
      </FormField>

      <FormField label={t('password')}>
        <Input
          type={showPassword ? 'text' : 'password'}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder={t('passwordPlaceholder')}
          required
          leftIcon={<Lock className="w-4 h-4" aria-hidden="true" />}
          rightIcon={
            <IconButton
              type="button"
              variant="ghost"
              size="xs"
              icon={showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              label={showPassword ? t('hidePassword', { defaultValue: 'Ocultar senha' }) : t('showPassword', { defaultValue: 'Mostrar senha' })}
              onClick={() => setShowPassword(!showPassword)}
            />
          }
        />
      </FormField>

      <Button type="submit" className="w-full" loading={isPending}>
        {t('login')}
      </Button>
    </form>
  );
}
